<template>
  <v-main>
    <AppBar :back="() => { $router.replace({ name: '퍼블_본인인증', params: { certifyType: '1004' } }) }" />
    <v-layout column fill-height>

      <v-container flex-fill fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">본인</span> 인증 정보 확인
          </h3>
          <p class="desc">
            회원님이 인증한 정보를 확인해 주세요.
          </p>
        </div>

        <div class="account-identity-content">
          <div class="account-identity-body">
            <v-form class="form-item" @submit.prevent @reset.prevent>
              <template v-for="(item, i) in items">
                <div :key="i" class="form-item-block">
                  <label class="label" v-text="item.label"/>
                  <div v-if="item.formType === 'CHOICE'" class="input-group">
                    <v-radio-group :value="form[item.name]"
                                   row mandatory
                                   class="radio-btn-group flex-grow-1"
                                   readonly
                    >
                      <template v-if="item.options && item.options.length > 0">
                        <v-radio v-for="(option, j) in item.options" :key="`radio_${j}`"
                                 :label="option.label"
                                 :value="option.value" />
                      </template>
                    </v-radio-group>
                  </div>
                  <div v-else class="input-group">
                    <v-text-field solo filled single-line required
                                  :value="form[item.name]"
                                  readonly />
                  </div>
                </div>
              </template>
            </v-form>
          </div>
        </div>
      </v-container>
      <v-footer app class="content-footer" color="transparent">
        <div class="footer-btns">
          <v-btn :disabled="!valid" class="btn-basic"
                 color="primary" depressed
                 x-large
                 @click="onSubmit"
          >다음
          </v-btn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>

<script>
// import store from '@/store'
import Util from '@/utils/utils'
import store from "@/store";
const ITEMS = () => {
  return [
    { formType: 'SHORT', name: 'username', label: '이름' },
    { formType: 'SHORT', name: 'birth', label: '생년월일' },
    { formType: 'CHOICE', name: 'gender', label: '성별', options: [{ label: '남자', value: '01' }, { label: '여자', value: '02' }] },
    { formType: 'SHORT', name: 'phone', label: '휴대전화' }
  ]
}
  const FORM = () => {
  return {
    username: null,
    birth: null,
    gender: null,
    phone: null
  }
}

export default {
  components: {},
  data: () => ({
    items: ITEMS(),
    form: FORM(),
    valid: false,
  }),
  computed: {
    joinUser () {
      return store.state.memberJoin.joinUser
    },
    division () {
      return store.state.memberJoin.joinUser.division
    }
  },
  watch: {},
  created () {
    this.form = {
      username: this.joinUser.userName,
      birth: this.formatDate(this.joinUser.birthyyMmday),
      gender: this.joinUser.gender,
      phone: Util.Common.replacePhoneNumber(this.joinUser.mobileNo)
    }
  },
  mounted() {
    //division 유실된경우 새로고침등 로그인 페이지로 보냄
    if (this.division == "" || this.division == undefined || this.division == null) {
      window.location.href = '/user/login'
    }
    setTimeout(function () {
      this.valid = true
    }.bind(this), 1000)
  },
  methods: {
    formatDate(input) {
      if (/^\d{4}\*\*\*\*$/.test(input)) {
        return input.slice(0, 4) + "-**-**";
      } else if (/^\d{8}$/.test(input)) {
        return input.slice(0, 4) + "-" + input.slice(4, 6) + "-" + input.slice(6, 8);
      }
      return "Invalid format";
    },
    onSubmit() {
      this.$router.push({name: '이메일 가입'})
    }
  }
}
</script>

<style lang="scss">
.account-identity {
  &-content {
    margin-top: 35px;
  }

  &-header {
    line-height: 140%;
  }

  &-label {
    margin-bottom: 10px;
  }

  &-title {
    display: flex;
    align-items: center;
    font-size: 16px;

    b {
      margin-left: 10px;
    }
  }
  &-body {
    .form-item-block {
      & + .form-item-block {
        margin-top: 10px;
        .label {
          margin-top: 20px;
        }
      }
      .v-input--selection-controls {
        padding-top: 0;
      }
    }
  }
}
</style>

